import { render, staticRenderFns } from "./CopyBtn.vue?vue&type=template&id=c7cd86ba"
import script from "./CopyBtn.vue?vue&type=script&lang=ts"
export * from "./CopyBtn.vue?vue&type=script&lang=ts"
import style0 from "./CopyBtn.vue?vue&type=style&index=0&id=c7cd86ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports